<template>
  <div class="dynamic-field">
    <button
        v-if="showRemoveAction"
        class="btn-remove-df"
        title="Remover este campo"
        v-on:click="remove(field)"
    >
      &times;
    </button>
    <b-field
        :label="`${field.title}${field.required ? ' *' : ''}`"
        v-if="field.type === 'text' || field.type === 'number'"
    >
      <input
          :placeholder="field.title"
          :type="field.type"
          :name="field.key"
          :value="dinamycValueFields[field.key]"
          :disabled="field.disabled"
          class="input"
          :v-validate="`${field.required ? 'required': ''}`"
          v-on:input="onChange(field.key, $event.target.value)"
      />
    </b-field>
    <b-field
        :label="`${field.title}${field.required ? ' *' : ''}`"
        v-if="field.type === 'textarea'"
    >
      <textarea
          :placeholder="field.title"
          :name="field.key"
          :disabled="field.disabled"
          rows="4"
          class="textarea"
          :v-validate="`${field.required ? 'required': ''}`"
          v-model="dinamycValueFields[field.key]"
      ></textarea>
    </b-field>

    <div class="operation-type-container" v-if="field.type === 'operationType'">
      <OperationType
        :field="field"
        :value="dinamycValueFields[field.key]"
        @operation-types-change="onOperationTypesChange"
      />
    </div>

    <vs-checkbox
        v-if="field.type === 'checkbox'"
        class="justify-content-start checkbox-item align-vertical-checkbox"
        v-model="dinamycValueFields[field.key]"
        :disabled="field.disabled"
    >
      {{ field.title }}
    </vs-checkbox>

    <b-field
        :label="`${field.title}${field.required ? ' *' : ''}`"
        v-if="field.type === 'select' && field.key!=='slot' "
    >
      <b-select
          :placeholder="field.title"
          expanded
          :name="field.key"
          v-model="dinamycValueFields[field.key]"
          :disabled="field.disabled"
      >
        <option
            v-for="option in field.options"
            :value="option.id"
            :key="option.id"
            :id="option.id"
        >
          {{ option.text }}
        </option>
      </b-select>
    </b-field>

    <b-field
        :label="`${field.title}${field.required ? ' *' : ''}`"
        v-if="field.type === 'select' && field.key ==='slot' "
    >
      <b-select
          :placeholder="field.title"
          expanded
          :name="field.key"
          v-model="dinamycValueFields[field.key]"
          :disabled="field.disabled"
      >
        <option
            v-for="option in slotList"
            :value="option.code"
            :key="option.code"
            :id="option.code"
        >
          {{ option.name }}
        </option>
      </b-select>
    </b-field>
  </div>
</template>
<script>
import OperationType from './OperationType.vue';

export default {
  props: {
    showRemoveAction: {
      type: Boolean,
    },
    field: {
      type: Object,
      default: {},
    },
    index: {
      type: Number,
      default: 0,
    },
    dinamycValueFields: {
      type: Object,
      default: [],
    },
    slotList: {
      type: Array,
      default: []

    }
  },
  components: {
    OperationType,
  },
  mounted() {
    const isOpType = this.field && this.field.type === 'operationType'
    if (!isOpType) return
    const existing = this.dinamycValueFields[this.field.key]
    if (Array.isArray(existing)) return
    this.$set(this.dinamycValueFields, this.field.key, [])
  },
  methods: {
    onChange(key, value) {
      this.$emit("onChange", {key: key, value: value});
    },
    remove(field) {
      this.$emit("removeAction", field);
    },
   onOperationTypesChange(payload) {
     const list = Array.isArray(payload) ? payload : []
     const filtered = list.filter((p) => p && p.vehicleType && p.operationType)
     this.$set(this.dinamycValueFields, this.field.key, filtered)
   },
  //  onOperationTypesChange(payload) {
  //    const list = Array.isArray(payload) ? payload : []
  //    const filtered = list.filter((p) => p && p.vehicleType && p.operationType)
  //    this.$set(this.dinamycValueFields, this.field.key, filtered)
  //  },
  },
};
</script>
<style>
.align-vertical-checkbox {
  margin-top: 40px;
}
</style>
